module.exports = __webpack_public_path__ + "img/essay-db-inactive.55bc5df0.png";